import { useState, useEffect } from 'react';
import produce from 'immer';
import { api } from '../repositories/HttpRepository';

export default function useFetchList(baseUrl, filter) {
  const [data, setData] = useState(filter);

  useEffect(() => {
    api.get(baseUrl, filter).then((response) => {
      setData(
        produce(data, (draftState) => {
          draftState.fetching = false;
          if (response.ok) {
            draftState.items = response.data.items ? response.data.items : [];
            draftState.total = response.data.total ? response.data.total : 0;
          }
        }),
      );
    });
  }, [filter]);

  return data;
}
